module.exports = __webpack_public_path__ + "img/overview-top-2.7626e02c.png";